import React from 'react'

import Endpoint from './Endpoint'

// Map verb short to long names
const VERBS = {
  'get': 'GET',
  'options': 'OPTS',
  'post': 'POST',
  'put': 'PUT',
  'patch': 'PATCH',
  'delete': 'DEL',
}

// Priority of verbs to display
const VERB_PRIORITY = Object.keys(VERBS)

// Prioritize an array by verb
const prioritize = (a, b) => {
  return VERB_PRIORITY.indexOf(a.verb) - VERB_PRIORITY.indexOf(b.verb)
}

const Endpoints = ({
  endpoints = []
}) => (
  <>
    { endpoints.sort(prioritize).map((endpoint) => (
      <Endpoint 
        key={endpoint.id}
        verb={VERBS[endpoint.verb]}
        endpoint={endpoint} />
      ))
    }
  </>
)

export default Endpoints